module.exports = __webpack_public_path__ + "fonts/Gibson-Regular.21140248.ttf";